import { Button, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { TaskGroupCardForTemplate } from "../../../components/ProjectTasks/TaskGroupCardForTemplate";
import AddInlineData from "../../../components/ProjectTasks/AddInlineData";
import { GlobalSearch } from "../../../components/GlobalSearch/GlobalSearch";
import swal from "sweetalert";
import AppContext from "../../../Context/AppContext";
import BottomBar from "../../../components/ProjectTasks/BottomBar";
import AwsServerService from "../../../common/util/AwsServerService";
import { convertToUSTime } from "../../../components/HR/TimeClock/Util";
import { canAccess } from "../../../common/util/appUtils";
import { useSelector } from "react-redux";


const TaskListTab = ({
  viewTaskFunction,
  groupFilter,
  setOpenTaskModal,
  pipelineData,
  isSubTaskView,
  setIsSubTaskView,
  setPipelineData,
  refreshData, 
  setPageRefreshData,
  allPipelineData,
  selectedTable,
  allBlueprintsData,
  dropdownTasksDataCache,
  allTasksAndSubtasks,   
  setDependencyRefresh,  
  allDependeniesData,
  viewPipeline,
  isPipelineModalClosed,
  isAdding,
  setIsAdding
}) => {
  let user = JSON.parse(localStorage.getItem("userinfo")); 
  const [searchTaskList, setSearchTaskList] = useState('')
  const [selectedIdsForTemp, setSelectedIdsForTemp] = useState({Task:[],Subtask:[]});
  const [dummyObj, setDummyObj] = useState({});
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const [subEditData, setSubEditData] = useState({
    id: Date.now(),
    Assignee: "",
    Priority: "",
    CREATEDBY: user.email_id,
    Supervisor: "",
    TaskDescription: "",
    TaskName: "",
    PipelineROWID: "",
    TimeEstimate: "",
    DueDate: convertToUSTime(new Date()),
    StartDate: convertToUSTime(new Date()),
  });
  const AppData = useContext(AppContext);
  const { state } = AppData || {};

  const [filteredTasks, setFilteredTasks] = useState([]);

  useEffect(() => {
    if (pipelineData) {
      if(searchTaskList){
        const filtered = pipelineData.Tasks.filter(task =>
          task.TaskName.toLowerCase().includes(searchTaskList.toLowerCase())
        );
        setFilteredTasks(filtered);
      }else{
        setFilteredTasks(pipelineData?.Tasks ? pipelineData?.Tasks : []);
      }
    }
  }, [refreshData,searchTaskList, pipelineData?.Tasks?.length , pipelineData?.Tasks, pipelineData]);

  useEffect(
    (e) => {
      if (pipelineData) {
        setSubEditData(prev=>{return {
          ...prev,
          PipelineROWID: pipelineData?.PipelineROWID || pipelineData?.ROWID,
        }});
      }
    },
    [pipelineData]
  );

  useEffect((e) => {
    setIsAdding(false);
    if(isPipelineModalClosed){
      setSelectedIdsForTemp({Task:[],Subtask:[]})
    }
  },
  [isPipelineModalClosed]
);

  const handleAddRow = () => {
    setIsAdding(true);
    let updatedTasks = [...(pipelineData?.Tasks || []), subEditData];
    setPipelineData({ ...pipelineData, Tasks: updatedTasks });
  };

  // Save the data (simulate API call)
  const handleSave = async() => {
    // Set a flag to true for subEditData
    if(!subEditData?.TaskName){
      swal('Alert','Task Name can not be empty!',"warning")
      return
    }
    let data={...subEditData}
    if(pipelineData.PipelineROWID || pipelineData.ROWID){
      let item={...subEditData}
      let flowObj= allBlueprintsData?.filter(e=>e.DefaultFlow=="true")[0]; 
      item['TaskFlowObject']=flowObj;
      item['TaskFlowId']=flowObj?.ROWID;
      delete item["id"];
      delete item["flag"];
      item["PipelineROWID"] = pipelineData?.PipelineROWID || pipelineData?.ROWID;
      await AwsServerService.saveTaskInTemplate(item).then(e=>{
        data['TaskROWID']=e[0].insertId;
      })
    }
    data["flag"] = true;
      
    // Find the index of the object with the same id in pipelineData.Tasks
    const existingIndex = pipelineData?.Tasks.findIndex(
      (item) => item.id === data.id
    );

    if (existingIndex !== -1) {
      // Update the existing object with subEditData
      const updatedTasks = [...pipelineData.Tasks];
      updatedTasks[existingIndex] = {
        ...updatedTasks[existingIndex],
        ...data,
      };
      setPipelineData({
        ...pipelineData,
        Tasks: updatedTasks,
      });
    } else {
      setPipelineData({
        ...pipelineData,
        Tasks: [...pipelineData.Tasks, data],
      });
    }

    // Reset subEditData to default values
    setSubEditData(()=>{return {
      id: Date.now(),
      Assignee: "",
      Priority: "",
      CREATEDBY: user.email_id,
      Supervisor: "",
      TaskDescription: "",
      TaskName: "",
      TimeEstimate: "",
    }});
    setIsAdding(()=>false);
  };

  return (
    <>
      <div className="add-row-btn">
        <Button
          disabled={(!pipelineData?.PipelineName || isAdding || !canAccess(accessContext, "Pipeline Template", "Create"))}
          onClick={() => {
            if(!canAccess(accessContext, "Pipeline Template", "Create")){
              message.error("Permission Denied"); 
              return
            }
            setOpenTaskModal(true);
          }}
        >
          Add Task
        </Button>
      </div>
      <div className="TasksList-Table">
          <div style={{display : "flex", marginLeft: "5px", position:"sticky", left:"5px"}}>
                <GlobalSearch
                  text={searchTaskList}
                  onSearchFilterTexts={(text) =>
                  setSearchTaskList(text)
                }
              />
              <AddInlineData
                onAdd={(e) => {
                  if(searchTaskList){
                    return
                  }
                  if(!canAccess(accessContext, "Pipeline Template", "Create")){
                    message.error("Permission Denied"); 
                    return
                  }
                  handleAddRow();
                }}
                onSave={(e) => {
                  handleSave();
                }}
                isAdding={isAdding}
                name={"Add Task"}
                isAccess= {canAccess(accessContext, "Pipeline Template", "Create")}
              />
          </div>
        <TaskGroupCardForTemplate
          module={""}
          viewTaskFunction={viewTaskFunction}
          groupFilter={groupFilter}
          selectedTable={selectedTable}
          allPipelineData={allPipelineData}
          data={filteredTasks}
          header={"Task Name"}
          isSubTaskView={isSubTaskView}
          setIsSubTaskView={setIsSubTaskView}
          editData={subEditData}
          setEditData={setSubEditData}
          refreshData={refreshData}
          setPageRefreshData={setPageRefreshData}
          selectedIdsForTemp={selectedIdsForTemp}
          setSelectedIdsForTemp={setSelectedIdsForTemp}
          setDummyObj={setDummyObj}
          dummyObj={dummyObj}
          emptyData={undefined}
          setSelectedIds={()=>{}}
          selectedIds={[]}
          dropdownTasksDataCache={dropdownTasksDataCache}
          allTasksAndSubtasks   ={allTasksAndSubtasks}
          setDependencyRefresh  ={setDependencyRefresh}
          allDependeniesData    ={allDependeniesData}
          viewPipeline = {viewPipeline}
        />
        {(selectedIdsForTemp?.Task?.length > 0 || selectedIdsForTemp?.Subtask?.length > 0) && 
          <BottomBar 
            selectedIds={selectedIdsForTemp}
            setSelectedIds={setSelectedIdsForTemp} 
            setPageRefreshData={setPageRefreshData} 
            refreshData={refreshData}
            selectedTable={selectedTable}
            subTaskData={filteredTasks}
            setSubTaskData={setFilteredTasks}
            setIsAdding={setIsAdding}
            allPipelineData={allPipelineData}
            setSubEditData={setSubEditData}
            setUpdateFlag={()=>{}}
            allTasksAndSubtasks={allTasksAndSubtasks}
            />
        }
      </div>
    </>
  );
};

export default TaskListTab;